import { Outlet, useLocation, useParams } from "@tanstack/react-router";
import { BarChart3, CalendarOff, List, Network, type LucideIcon } from "lucide-react";
import { useCore } from "../lib/core";
import { SideNav, type SideNavItem } from "../components/SideNav";

export function PeopleHome() {
  const core = useCore();
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const location = useLocation();
  const canManage = core.rbac.can("manage", "hotel");
  const canManageUsers = core.rbac.can("manage", "user");
  const myUid = core.auth.currentUserId();

  // Active state is computed here (we are under the router) and passed to
  // SideNav, which is router-agnostic.
  const item = (key: string, labelKey: string, icon: LucideIcon, path: string): SideNavItem => {
    const to = `/${tenantSlug}/people${path}`;
    return {
      key,
      label: core.i18n.t(labelKey),
      icon,
      to,
      active: location.pathname.startsWith(to),
    };
  };

  // MED-07: managers get the list/workload + manager-level leaves views; staff
  // only get their own leaves tab (a different route).
  const items: SideNavItem[] = [];
  if (canManageUsers) {
    items.push(item("list", "people.nav.list", List, "/list"));
    items.push(item("workload", "people.nav.workload", BarChart3, "/workload"));
    items.push(item("leaves", "people.nav.leaves", CalendarOff, "/leaves"));
  } else if (myUid) {
    items.push(item("myLeaves", "people.nav.myLeaves", CalendarOff, `/${myUid}/leaves`));
  }
  if (canManage) {
    items.push(item("structure", "people.nav.structure", Network, "/structure"));
  }

  return (
    <section className="flex flex-1 flex-col md:flex-row">
      <SideNav title={core.i18n.t("people.title")} items={items} />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </section>
  );
}
